import { createContext, useContext, useReducer } from 'react';
import { BaseInternalFormState, BaseInternalFormReducer, ACTION_TYPES } from './base-internal-form-reducer';


const BaseInternalFormContext = createContext<BaseInternalFormState | undefined>(undefined);
const BaseInternalFormContextDispatchContext = createContext({} as any);

const BaseInternalFormProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(BaseInternalFormReducer, { drawerOpen:true} as BaseInternalFormState);

    return (

        <BaseInternalFormContext.Provider value={state}>
            <BaseInternalFormContextDispatchContext.Provider value={dispatch}>
                {children}
            </BaseInternalFormContextDispatchContext.Provider>
        </BaseInternalFormContext.Provider>

    );
}

const useBaseInternalFormState = () => {
    const context = useContext(BaseInternalFormContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useBaseInternalFormDispatch = () => {
    const context = useContext(BaseInternalFormContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { BaseInternalFormProvider, useBaseInternalFormDispatch, useBaseInternalFormState, ACTION_TYPES };
